"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _AbstractService2 = _interopRequireDefault(require("../../AbstractService"));

var _ServiceSettings = _interopRequireDefault(require("../../ServiceSettings"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

/**
 * This class handles generating application URL:s based on platform, storeId and language id.
 */
var ApplicationUrlService = /*#__PURE__*/function (_AbstractService) {
  _inherits(ApplicationUrlService, _AbstractService);

  var _super = _createSuper(ApplicationUrlService);

  function ApplicationUrlService() {
    _classCallCheck(this, ApplicationUrlService);

    return _super.apply(this, arguments);
  }

  _createClass(ApplicationUrlService, [{
    key: "getUrls",

    /**
     * Returns application URL:s.
     *
     * @example { SHOPPINGLIST: String, SHOPPINGLIST: String, LOGIN: String, TRANSPORTLINK: String, PIP: String }
     * @param {object} localData Localization data retrieved from LocalizationService.
     * @returns {Promise} Promise object.
     */
    value: function getUrls(localData) {
      var _this = this;

      return new Promise(function (resolve) {
        if (_ServiceSettings.default.uiPlatform.includes('kiosk')) {
          resolve({
            SHOPPINGCART: '',
            SHOPPINGLIST: '',
            LOGIN: '',
            TRANSPORTLINK: '',
            PIP: ''
          });
        } else {
          var shoppingCartLink = localData.URLs ? localData.URLs.shoppingCartLink || '' : '';
          var shoppingListLink = localData.URLs ? localData.URLs.shoppingListLink || '' : '';
          var transportLink = localData.URLs ? localData.URLs.transportLink || '' : '';
          var productInformationPageLink = localData.URLs ? localData.URLs.productInformationPageLinkV2 || '' : '';
          resolve({
            SHOPPINGCART: _this._replaceCountryAndLanguageCode(shoppingCartLink, localData),
            SHOPPINGLIST: _this._replaceCountryAndLanguageCode(shoppingListLink, localData),
            LOGIN: '',
            TRANSPORTLINK: _this._replaceCountryAndLanguageCode(transportLink, localData),
            PIP: _this._replaceCountryAndLanguageCode(productInformationPageLink, localData).replace('{productItemNo}', '{articleID}')
          });
        }
      });
    }
    /**
     * Replaces country and language code.
     *
     * @param {string} url URL to replace in.
     * @param {object} localData Localization data retrieved from LocalizationService.
     * @returns {string} URL with replaced values.
     */

  }, {
    key: "_replaceCountryAndLanguageCode",
    value: function _replaceCountryAndLanguageCode(url, localData) {
      return url.replace('{country}', localData.localization.countryCode).replace('{language}', localData.localization.languageCode);
    }
    /**
     * Returns the name used by ServiceFactory.
     *
     * @override
     * @returns {string} Factory name.
     */

  }], [{
    key: "factoryName",
    get: function get() {
      return 'applicationurl';
    }
  }]);

  return ApplicationUrlService;
}(_AbstractService2.default);

exports.default = ApplicationUrlService;